import React from "react";
import {Checkpoint, GarageType} from "@App/types";

type CheckpointDetailsProps = {
    checkpoint: Checkpoint
    garageType?: GarageType
    hideDescription?: boolean
};

export const CheckpointDetails = React.memo<CheckpointDetailsProps>(({
                                                                         checkpoint,
                                                                         garageType,
                                                                         hideDescription
                                                                     }: CheckpointDetailsProps) => {
    return (
        <div className={`mb-6`}>
            {checkpoint.logo && (
                <img className="mb-3" src={`/storage/${checkpoint.logo}`} alt={checkpoint.name}/>
            )}
            <div className="text-lg font-bold slab-font mb-1">
                Die Prüfung erfolgt durch: {checkpoint.name}
            </div>
            {!hideDescription && garageType && garageType.name === 'Prüfstelle' && (
                <p>
                    Fahrzeuguntersuchungen sind in Deutschland genau geregelt. Die Tätigkeit von Prüfgesellschaften ist
                    streng reglementiert und wird durch die staatlichen Aufsichtsbehörden kontrolliert, um die Qualität
                    und die Unabhängigkeit der vorgenommenen Prüfungen zu gewährleisten.
                </p>
            )}
            {!hideDescription && (!garageType || (garageType && garageType.name !== 'Prüfstelle')) && (
                <p>
                    Ein neutraler, staatlich anerkannter Prüfer kommt direkt zur Werkstatt und prüft dein Fahrzeug.
                    Falls du zusätzlich einen Vorabcheck wünschst, um prüfen zu lassen, ob dein Auto "durch die Prüfung
                    kommt", kannst du das im nächsten Buchungsschritt vermerkern.
                </p>
            )}
        </div>
    );
})
